import { ampersandList, formatServerEnumName } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";
import { IProps } from "./interaction-types-summary.types";
import "./interaction-types-summary.scss";
import { InteractionType } from "@edgetier/watchtower-types";

const InteractionTypesSummary: FunctionComponent<IProps> = ({ interactionTypes }) => {
    if (interactionTypes.length < Object.keys(InteractionType).length) {
        return (
            <>
                {ampersandList(
                    interactionTypes.map((interactionType) => formatServerEnumName(interactionType)),
                    { sort: true }
                )}
            </>
        );
    }
    return <>All</>;
};

export default memo(InteractionTypesSummary);
